import React, { useState, useEffect, memo, useRef } from "react";
import { useTranslation } from "react-i18next";
import DoughnutGraph from "@components/graphStatistics/Doughnut/Graphs";
import { customTooltips } from "@helpers/_functions";

export default memo(function Index({ employeesPerCountries }) {
  const [graphData, setGraphData] = useState({});
  const { t } = useTranslation("pages.employés.statistics");
  const chartRef = useRef(null);
  useEffect(() => {
    let countriesData = {};
    if (employeesPerCountries?.length) {
      countriesData = {
        datasets: [
          {
            data: employeesPerCountries?.map((item) => item?.count) || [],
            backgroundColor:
              employeesPerCountries?.map((item) => item?.backgroundColor) || [],
            hoverOffset: 4
          }
        ],
        labels: employeesPerCountries.map(({name, count, percentValue }) => `${name} : ${count} (${percentValue}%)`) || [],
      };
    }
    setGraphData(countriesData);
  }, [employeesPerCountries]);

 
  const translatedLegends = employeesPerCountries
    ?.map(({ name, backgroundColor }) => ({
      name: t(name),
      backgroundColor
    }))
    .sort(({ name: nameA }, { name: nameB }) =>
      nameA?.toLowerCase() < nameB?.toLowerCase() ? -1 : 1
    );
    const customOptions = {
      tooltips: {
        enabled:false,
        custom: (tooltip)=>customTooltips(tooltip,chartRef,t),
      },
    };
  return (
    <DoughnutGraph
      graphData={graphData}
      legends={translatedLegends}
      title={t("Pays d'origine")}
      spaceLegende="arh-space-y-2"
      customOptions={customOptions}
      chartRef={chartRef}
    />
  );
});
